import { PKIDomainURLs } from "./platform-domain.urls";

export class PKIBrandingDomainURLs {
    /**
     * Branding PKI Development (development.sbrsbv.nl).
     */
    public static DevelopmentBrandingUrl: string = "devplatform.pkisigning.io";
    /**
     * Branding PKI Test (test.sbrsbv.nl).
     */
    public static TestBrandingUrl: string = "test.sbrsbv.nl";
    /**
     * Branding PKI Acceptation (acceptatie.sbrsbv.nl).
     */
    public static AcceptationBrandingUrl: string = "acceptatie.sbrsbv.nl";
    /**
     * Branding PKI Production (ondertekenen.sbrsbv.nl).
     */
    public static ProductionBrandingUrl: string = "ondertekenen.sbrsbv.nl";
}
export function isNonBrandingUrl(url: string) {
    return Object.values(PKIDomainURLs).includes(url);
}

